import styled from 'styled-components'
import FontAwesome from 'react-fontawesome'
import { Link } from 'react-router-dom'

export const MainButtonWrapper = styled.div`
    position: fixed;
    bottom: 60px;
    right: 20px;
    width: 60px;
    height: 60px;
    background-color: var(--cyan);
    border-radius: 50%;
    z-index: 1;
    display: flex;
    justify-content: center;
    cursor: pointer;
`

export const FABButtonIcon = styled(FontAwesome)`
    color: #fff;
    margin-top: 15px;
`

export const FABButtonItemWrapper = styled.div`
    position: fixed;
    right: 20px;
    width: 60px;
    height: 60px;
    background-color: var(--cyan);
    border-radius: 50%;
    z-index: 1;
    display: flex;
    justify-content: center;
    ${props => (`
        bottom: ${((props.index + 1) * 70) + 80}px;
    `)}
`

export const FABButtonLink = styled(Link)`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
`

export const FABButtonAction = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Global/FABButton.js